export default "__VITE_ASSET__BHdjXZbS__"